import React, { useEffect } from 'react';
import { Amplify } from 'aws-amplify';
import { get } from 'aws-amplify/api';
import amplifyconfig from '../amplifyconfiguration.json';
import { getCurrentUser } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import Profile from "../Components/AppComponents/ProfileComponents";
import Sidebar from "../Components/AppComponents/Sidebar";

Amplify.configure(amplifyconfig);

export const ProfileComponent = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const user = await getCurrentUser();
        if (user) {
          try {
            const restOperation = get({ apiName: 'userapi', path: '/checkSubscription' });
            const { body } = await restOperation.response;
            const str = await body.text();
            if (str === "false") {
              navigate('/checkout');
            } else {
              sessionStorage.setItem("subscriptionStatus", str);
            }
          } catch (error) {
            console.log('ERROR CODE: PP01');
          }
        } 
      } catch (e) {
        navigate('/login');
        console.log("ERROR CODE: PP02");
      }
    };

    checkAuthStatus();
  }, [navigate]);

  return (
    <>
      <Sidebar />
      <Profile />
    </>
  );
};

export default ProfileComponent;
